( function (ImageOverlay) {
    'use strict';

    function TooltipTerm(id, selectorContainer, delay, textHint) {
        this._id = id;
        this._container = document.querySelector(selectorContainer);
        this._tagName = 'ATERM';
        this._delay = delay;
        this._textHint = textHint; // Текст или функция возвращающая текст подсказки

        this._top = 0; //Отступ от верхнего края для подсказки
        this._left = 0; //Отступ от левого края для подсказки
        this._timer = null;

        this._tooltip = this._createTooltipElement();
        this._bindHandlers();
    }

    /**
     *
     *
     */
    TooltipTerm.prototype.destroy = function () {
        this._clearHandlers();
        this._tooltip = null;
        this._container = null;
    };

    /**
     * Создаёт элемент для отображения подсказок
     *
     */
    TooltipTerm.prototype._createTooltipElement = function () {
        if (document.getElementById(this._id)) {
            return;
        }

        let element = document.createElement('div');
        element.id = this._id.split('#').join('');
        element.classList.add('tooltip-term');
        document.body.appendChild(element);

        return element;
    };

    /**
     * Возвращает текст полсказки
     *
     */
    TooltipTerm.prototype._getText = function (element) {
        return typeof this._textHint === 'function' ? this._textHint(element) : this._textHint;
    };

    /**
     * Закрывает подсказку
     *
     */
    TooltipTerm.prototype._close = function (delay) {
        delay = delay || 0;

        //Запускаем таймер и через указанное количестов времени закрываем подсказку,
        //т.к. курсор мыши уже распологается в другом месте
        this._timer = setTimeout(() => {
            if (this._tooltip.getAttribute('data-stop-close') === '0') {
                this._tooltip.style.display = 'none';
            }
        }, delay);
    };

    /**
     * Добавляет обработчики событий
     *
     */
    TooltipTerm.prototype._bindHandlers = function () {
        this._onElementMouseOver = this._onElementMouseOver.bind(this);
        this._container.addEventListener('mouseover', this._onElementMouseOver);

        this._onElementMouseOut = this._onElementMouseOut.bind(this);
        this._container.addEventListener('mouseout', this._onElementMouseOut);

        this._onTooltipMouseOut = this._onTooltipMouseOut.bind(this);
        this._tooltip.addEventListener('mouseout', this._onTooltipMouseOut);

        this._onTooltipMouseOver = this._onTooltipMouseOver.bind(this);
        this._tooltip.addEventListener('mouseover', this._onTooltipMouseOver);

        this._onTooltipImgClick = this._onTooltipImgClick.bind(this);
        this._tooltip.addEventListener('click', this._onTooltipImgClick);
    };

    /**
     * Удаляет обработчики событий
     *
     */
    TooltipTerm.prototype._clearHandlers = function () {
        this._container.removeEventListener('mouseover', this._onElementMouseOver);
        this._container.removeEventListener('mouseout', this._onElementMouseOut);

        this._tooltip.removeEventListener('mouseover', this._onTooltipMouseOut);
        this._tooltip.removeEventListener('mouseout', this._onTooltipMouseOut);
    };

    /**
     * Обрабочик события: получение фокуса
     *
     */
    TooltipTerm.prototype._onElementMouseOver = function (evt) {
        if (evt.target.tagName.toUpperCase() !== this._tagName) {
            return;
        }

        clearTimeout(this._timer);

        //Получаем текст подсказки
        let contentTooltip = this._getText(evt.target);
        if (!contentTooltip) {
            this._tooltip.style.display = 'none';
            return;
        }

        this._tooltip.setAttribute('data-stop-close', '0');

        //Заполняем подсказку текстом
        this._tooltip.innerHTML = contentTooltip;
        this._tooltip.style.display = 'block';

        //Рассчитывает координаты для расположения подсказки
        this._calcPosition(evt);

        this._tooltip.style.top = this._top + 'px';
        this._tooltip.style.left = this._left + 'px';
    };

    /**
     * Обрабочик события: потеря фокуса
     *
     */
    TooltipTerm.prototype._onElementMouseOut = function (evt) {
        if (evt.target.tagName.toUpperCase() !== this._tagName) {
            return;
        }

        //Запускаме таймер и через указанное количестов времени закрываме посказку,
        //т.к. курсор мыши уже распологается в другом месте
        this._close(this._delay);
    };

    /**
     * Обрабочик события: потеря фокуса блоком подсказки
     *
     */
    TooltipTerm.prototype._onTooltipMouseOut = function () {
        this._tooltip.setAttribute('data-stop-close', '0');

        this._close(0);
    };

    /**
     * Обрабочик события: получение фокуса блоком подсказки
     *
     */
    TooltipTerm.prototype._onTooltipMouseOver = function () {
        this._tooltip.setAttribute('data-stop-close', '1');
    };

    /**
     * Обрабочик события: клик по иконке изображения
     *
     */
    TooltipTerm.prototype._onTooltipImgClick = function (evt) {
        if (!evt.target.classList.contains('tooltip-term__img')) {
            return;
        }
        if (!ImageOverlay) {
            return;
        }

        let imageOverlay = new ImageOverlay('');
        imageOverlay.init().show(evt.target.getAttribute('data-link'));
    };

    /**
     * Рассчитывает координаты для расположения подсказки
     *
     */
    TooltipTerm.prototype._calcPosition = function (evt) {
        let positionX = evt.pageX;
        let positionY = evt.pageY + 20;
        let tipWidth = this._tooltip.offsetWidth; // Вычисляем длину подсказки
        let tipHeight = this._tooltip.offsetHeight; // Вычисляем высоту подсказки
        let scrollTop = window.scrollY || window.pageYOffset || document.documentElement.scrollTop;

        if (tipWidth >= window.innerWidth) {
            tipWidth = window.innerWidth - 10; //10 - чуть меньше ширины окна
            this._tooltip.style.maxWidth = tipWidth + 'px';
        }

        // Определяем дистанцию от правого края окна браузера до блока, содержащего подсказку
        let tipVisX = window.innerWidth - (positionX + tipWidth);

        // Определяем дистанцию от ниждего края окна браузера до блока, содержащего подсказку
        let tipVisY = window.innerHeight - ((positionY - scrollTop) + tipHeight);

        // Если ширина подсказки превышает расстояние от правого края окна браузера до курсора,
        if (tipVisX < 20) {
            positionX = evt.pageX - tipWidth - 20; // то распологаем область с подсказкой по другую сторону от курсора
        }
        if (tipVisY < 20) { // Если высота подсказки превышает расстояние от нижнего края окна браузера до курсора,
            positionY = evt.pageY - tipHeight - 20;  // то распологаем область с подсказкой над курсором
        }

        this._top = positionY;
        this._left = positionX <= 0 ? 5 : positionX;
    };

    let callback = function (element) {
        if (!element.querySelector('.term-description')) {
            return
        }

        return element.querySelector('.term-description').innerHTML;
    };

    if (!document.body.classList.contains('is-mobile-app')) {
        new TooltipTerm('#tooltip', 'body', 300, callback);
    }
}(window.ImageOverlay));